<template>
    <div>
        <form class="mb-3">
            <b-form-row>
                <b-form-group class="col-md-3" label="Fecha servicio desde *" >
                    <b-form-datepicker 
                        locale="es" 
                        :class="{'active-filter':filters.startDate}" 
                        reset-button size="sm" 
                        v-model="filters.startDate"/>
                </b-form-group>

                <b-form-group class="col-md-3" label="Hasta fecha de servicio *" >
                    <b-form-datepicker 
                        locale="es" 
                        :class="{'active-filter':filters.endDate}" 
                        reset-button  
                        size="sm" 
                        v-model="filters.endDate"/>
                </b-form-group>

                <b-form-group>
                    <b-button 
                        variant="warning" 
                        v-b-toggle="'advanced-filters'" 
                        class="btn mr-2 mt-4" 
                        id="advanced-filters">
                        <md-icon icon="filter_list"/>
                    </b-button>
                    <b-tooltip 
                        target="advanced-filters" 
                        triggers="hover">
                        Mostrar/Ocultar Filtros avanzados
                    </b-tooltip>
                    <b-button 
                        class="mt-4 mr-2"
                        variant="primary" 
                        type="button" 
                        @click="search()">
                        <md-icon icon="search"/>
                    </b-button>
                    <b-button 
                        class="mt-4"
                        @click="excel()"
                        variant="warning">Exportar XLS</b-button>
                </b-form-group>

            </b-form-row>

            <b-collapse id="advanced-filters">
                <b-form-row>
                    <b-form-group class="col-lg-4" label="Proveedor">
                        <multiselect
                        v-model="filters.suppliers"
                        :options="suppliersOpts"
                        group-label="group"
                        group-values="options"
                        group-select
                        multiple
                        label="text"
                        track-by="value"
                        placeholder="Todos"
                        taggable>
                        <template v-slot:clear >
                            <div class="multiselect__clear" @click="filters.suppliers = []">
                            </div>
                        </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-lg-4" label="Estado de servicio">
                        <multiselect
                        v-model="filters.status"
                        :options="statusOpts"
                        group-label="group"
                        group-values="options"
                        group-select
                        multiple
                        label="text"
                        track-by="value"
                        placeholder="Todos"
                        taggable>
                        <template v-slot:clear >
                            <div 
                            class="multiselect__clear" 
                            @click="filters.status = []">
                            </div>
                        </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-lg-4 mt-0" label="Canal de venta">
                        <multiselect
                        :class="{'active-filter':filters.salesChannels.length>0}"
                        v-model="filters.salesChannels"
                        :options="channelOpts"
                        multiple
                        label="text"
                        placeholder="Todos"
                        taggable
                        track-by="value">
                        <template v-slot:clear >
                            <div class="multiselect__clear" @click="filters.salesChannels = []">
                            </div>
                        </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group class="col-lg-6" label="Zonas Master">
                        <multiselect v-model="filters.zones"
                            :options="zonedAreasGroupedOpts"
                            :multiple="true"
                            group-values="zones"
                            group-label="zonedArea"
                            :group-select="true"
                            placeholder="Type to search"
                            track-by="text"
                            label="text">
                            <span slot="noResult">Oops! No se encontraron resultados.</span>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="filters.zones = []"></div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc" v-if="props.option.$groupLabel">
                                    <span class="option__title">{{ props.option.$groupLabel }}</span><br>
                                </div>
                                <div class="option__desc"  v-else>
                                    <span class="option__title">{{ props.option.text }}</span><br>
                                    <small class="option__small text-muted">
                                        {{ props.option.zonedAreaName }}
                                    </small>
                                </div>
                            </template>
                            <template slot="option-group" slot-scope="props">
                                <div class="option__desc">
                                    <span class="option__title">{{ props.option.text }}</span><br>
                                    <small class="option__small text-muted">
                                    {{ props.option.zonedAreaName }}
                                    </small>
                                </div>
                            </template>
                        </multiselect>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-1"
                        label="Viaje">
                        <b-form-select
                            :class="{ 'active-filter': filters.trip }"
                            v-model="filters.trip"
                            :options="tripOpts"/>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-2"
                        label="Driver Events">
                        <b-form-select
                            :class="{ 'active-filter': filters.driverEvents }"
                            v-model="filters.driverEvents"
                            :options="driverEventsOpts"/>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-2"
                        label="Derecho de piso">
                        <b-form-select
                            :class="{ 'active-filter': filters.placeTimePayment }"
                            v-model="filters.placeTimePayment"
                            :options="placeTimeOpts"/>
                    </b-form-group>

                    <b-form-group
                        class="col-lg-2"
                        label="Conductor">
                        <b-form-select
                            :class="{ 'active-filter': filters.driverOpts }"
                            v-model="filters.withDriver"
                            :options="driverOpts"/>
                    </b-form-group>
                </b-form-row>
            </b-collapse>
        </form>


        <b-tabs content-class="mt-3" v-model="tabActive">
            <b-tab title="Reporte" active>
                <!-- Loading -->
                <div v-if="loading" class="col-12 text-center pt-5">
                    <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
                    <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
                    <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
                </div>
                <!-- End Loading -->

                <div class="py-3" v-else>
                    <b-row>
                        <b-col class="mb-2">
                            <div class="mr-4">
                                <span>{{ rowsMessage }}</span>
                                <b-form-select
                                    size="sm"
                                    class="ml-2"
                                    id="perPageSelector"
                                    v-model="perPage"
                                    :options="perPageOptions"
                                    @change="updateTable"
                                ></b-form-select>
                            </div>
                        </b-col>
                        <b-col class="text-right">
                            <b-pagination
                                v-model="currentPage"
                                align="right"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                @input="onPageChange"
                            />
                        </b-col>
                    </b-row>

                    <b-table
                        id="spit-main-table"
                        show-empty
                        hover
                        small
                        bordered
                        stacked="lg"
                        :items="table.body" 
                        :fields="table.fields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        responsive>

                        <!-- A virtual column -->
                        <template #cell(serviceNumber)="data">
                            <strong>{{ data.item.serviceNumber }}</strong>
                            <div class="text-left">
                                <b-badge variant="info" class="mr-1 text-uppercase">{{ data.item.sales_channel.name }}</b-badge>
                                <b-badge variant="info" class="mr-1 text-uppercase">{{ data.item.supplier.name }}</b-badge>
                            </div>
                            <div class="text-left">
                                <b-badge :variant="variantStatus[data.item.status]" class="mr-1 text-uppercase">{{ statusLabels[data.item.status] }}</b-badge>
                            </div>
                        </template>

                        <template #cell(pickupDatetime)="data">
                            <span class="text-nowrap">{{ data.item.pickupDatetime }}</span>
                        </template>

                        <template #cell(user_driver)="data">
                            <span class="text-nowrap" v-if="data.item.user_driver">
                                {{ data.item.user_driver.firstName }} 
                                {{ data.item.user_driver.lastName }} 
                                <b-badge variant="primary" class="mr-1 text-uppercase" v-if="data.item.user_driver.tia">TIA</b-badge>
                            </span>
                        </template>

                        <template #cell(onWayToPickup)="data">
                            <div class="text-right">
                                <template v-if="(eventData = getDriverEventData(data.item.driver_geo_tracking, data.field.key))">
                                    <div><b-badge variant="secondary" class="mr-1">{{ eventData.user }} <md-icon icon="person"/></b-badge></div>
                                    <span class="text-nowrap">{{ eventData.date }}</span>
                                    <div><b-badge variant="info" class="mr-1">
                                        {{ data.item.pickupToOnWayToPickupLapse }} min 
                                        {{ data.item.pickupToOnWayToPickupDistance }} km
                                    </b-badge></div>
                                </template>
                                <div v-else class="text-muted">Sin datos</div>
                            </div>
                        </template>

                        <template #cell(atPickup)="data">
                        <div class="text-right">
                            <template v-if="(eventData = getDriverEventData(data.item.driver_geo_tracking, data.field.key))">
                                <div><b-badge variant="secondary" class="mr-1">{{ eventData.user }} <md-icon icon="person"/></b-badge></div>
                                <span class="text-nowrap">{{ eventData.date }}</span>
                                <div><b-badge variant="info" class="mr-1">
                                    {{ data.item.pickupToAtPickupLapse }} min 
                                    {{ data.item.pickupToAtPickupDistance }} km
                                </b-badge></div>
                            </template>
                            <div v-else class="text-muted">Sin datos</div>
                        </div>
                        </template>

                        <template #cell(onWayToDropoff)="data">
                        <div class="text-right">
                            <template v-if="(eventData = getDriverEventData(data.item.driver_geo_tracking, data.field.key))">
                                <div><b-badge variant="secondary" class="mr-1">{{ eventData.user }} <md-icon icon="person"/></b-badge></div>
                                <span class="text-nowrap">{{ eventData.date }}</span>
                                <div>
                                    <b-badge variant="info" class="mr-1">
                                        {{ data.item.pickupToOnWayToDropoffLapse }} min 
                                        {{ data.item.pickupToOnWayToDropoffDistance }} km
                                    </b-badge>
                                </div>
                                <div>
                                    <b-badge variant="warning" class="mr-1">
                                        {{ data.item.atPickupToOnWayToDropoff }} min 
                                        {{ data.item.atPickupToOnWayToDropoffDistance }} km 
                                        de atPickup
                                    </b-badge>
                                </div>

                                <div>
                                    <b-badge variant="danger" class="mr-1" v-if="data.item.placeTimePayment == true">
                                        Derecho de piso
                                    </b-badge>
                                </div>
                            </template>
                            <div v-else class="text-muted">Sin datos</div>
                        </div>
                        </template>

                        <template #cell(finished)="data">
                        <div class="text-right">
                            <template v-if="(eventData = getDriverEventData(data.item.driver_geo_tracking, data.field.key))">
                                <div><b-badge variant="secondary" class="mr-1">{{ eventData.user }} <md-icon icon="person"/></b-badge></div>
                                <span class="text-nowrap">{{ eventData.date }}</span>
                                <b-badge variant="info" class="mr-1">
                                    {{ data.item.pickupToFinishedLapse }} min 
                                    {{ data.item.pickupToFinishedDistance }} km
                                </b-badge>
                            </template>
                            <div v-else class="text-muted">Sin datos</div>
                        </div>
                        </template>

                        <template #cell(timeLapseFormated)="data">
                            <span class="text-nowrap">
                                {{ data.item.timeLapseFormated }}
                                <div><b-badge variant="secondary" class="mr-1">{{ data.item.distance }}</b-badge></div>
                            </span>
                        </template>

                        <template #cell(actions)="data">
                            <div class="text-right">
                                <b-button variant="info" size="sm" title="Ver mapa" @click="showMap(data.item)">
                                    <md-icon icon="pin_drop"/>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </b-tab>

            <b-tab title="Estadisticas">
                <b-overlay :show="loading">
                    <b-card-group deck style="color: black;">
                        <b-card
                            border-variant="primary"
                            header="Conductores"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <b-row>
                                <b-col cols="7">
                                    <span>Servicios asignados</span>
                                </b-col>
                                <b-col class="text-right">
                                    <b>{{ panels.drivers.assigned.value }} / {{ panels.drivers.assigned.percent }}%</b>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="7">
                                    <span>Servicios no asignados</span>
                                </b-col>
                                <b-col class="text-right">
                                    <b>{{ panels.drivers.notAssigned.value }} / {{panels.drivers.notAssigned.percent}}%</b>
                                </b-col>
                            </b-row>
                        </b-card>
            
                        <b-card
                            border-variant="primary"
                            header="Driver App"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <b-row>
                                <b-col cols="7">
                                    <span>Servicios finalizado con éxito</span>
                                </b-col>
                                <b-col class="text-right">
                                    <b>{{panels.driverAppUse.finished.value}} / {{panels.driverAppUse.finished.percent}}%</b>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="7">
                                    <span>Servicios no completados</span>
                                </b-col>
                                <b-col class="text-right">
                                    <b>{{panels.driverAppUse.notFinished.value}} / {{panels.driverAppUse.notFinished.percent}}%</b>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card
                            border-variant="primary"
                            header="Tracking Status"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <div  v-for="item in trackingStatus" :key="item.value">
                                <b-row class="mb-1">
                                    <b-col cols="7">
                                        <span>{{item.text}}</span>
                                    </b-col>
                                    <b-col class="text-right">
                                        <b>{{getDataTrackingStatus(item.value,'value')}} / {{getDataTrackingStatus(item.value,'percent')}}%</b>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-card-group>
                </b-overlay>
            </b-tab>
        </b-tabs>

        <b-modal ref="modal-map-events" size="xl" title="Mapa de eventos" hide-footer>
            <MapEvents :ride="serviceSelected"/>
        </b-modal>
    </div>
</template>
<script>

import moment from 'moment'
import api from "../../../../api.js";
import Multiselect from 'vue-multiselect';
import MapEvents from './MapEvents.vue';
export default {
    name: "driver-events",
    components: {Multiselect, MapEvents},
    data() {
        
        let start = moment().startOf('month').format('YYYY-MM-DD');
        let end   = moment().format('YYYY-MM-DD');

        return {
			loading: false,
			codeReport: "driver-events",
            sortBy: 'index',
            sortDesc: true,
            perPage: 10,
			currentPage: 1,
            offsetTable: 0,
			totalRows: 0,
            perPageOptions: [
				{ value: 10, text: 10 },
				{ value: 50, text: 50 },
				{ value: 100, text: 100 },
				{ value: 200, text: 200 },
				{ value: 500, text: 500 }
			],
			filters: {
				startDate: start,
				endDate: end,
                suppliers: [],
                status: [
                    {value:"active", text:"Activo",    class:"default"},
                    {value:"done",   text:"Realizado", class:"success"},
                    {value:"noShow", text:"No show",   class:"info"}
                ],
                salesChannels: [],
                zones: [],
                trip: 'all',
                placeTimePayment: 0,
                driverEvents: 'with_events',
                withDriver: 'all'
			},
            placeTimeOpts: [
                {value: 0, text: 'Todos'},
                {value: 1, text: 'Con derecho de piso'},
                {value: 2, text: 'Sin derecho de piso'},            
            ],
            driverEventsOpts: [
                {value: 'all', text: 'Todos'},
                {value: 'with_events', text: 'Con driver events'},
                {value: 'without_events', text: 'Sin driver events'},            
            ],
            driverOpts: [
                {value: 'all', text: 'Todos'},
                {value: 'with_driver', text: 'Con conductor asignado'},
                {value: 'without_driver', text: 'Sin conductor asignado'}
            ],
            events: [],
            table: {
                body: [],
                fields: [
                    {
                        key: 'serviceNumber',
                        label: 'Res ID',
                        sortable: false
                    },
                    {
                        key: 'tripType',
                        label: 'Viaje',
                        sortable: true
                    },
                    {
                        key: 'pickup_place.name',
                        label: 'Pickup',
                        sortable: true
                    },
                    {
                        key: 'dropoff_place.name',
                        label: 'Dropoff',
                        sortable: true
                    },
                    {
                        key: 'pickupDatetime',
                        label: 'Pickup DateTime',
                        sortable: true
                    },
                    {
                        key: 'user_driver',
                        label: 'Conductor',
                        sortable: true
                    },
                    {
                        key: 'onWayToPickup',
                        label: 'OnWayToPickup',
                        sortable: false
                    },

                    {
                        key: 'atPickup',
                        label: 'AtPickup',
                        sortable: false
                    },

                    {
                        key: 'onWayToDropoff',
                        label: 'OnWayToDropoff',
                        sortable: false
                    },
                    {
                        key: 'finished',
                        label: 'Finished',
                        sortable: false
                    },
                    {
                        key: 'timeLapseFormated',
                        label: 'Tiempo Operación.',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones',
                        sortable: false
                    }
                ]
            },
            serviceSelected: null,
            panels: {
                drivers:{assigned:{value:0,percent:0},notAssigned:{value:0,percent:0}},
                driverAppUse:{finished:{value:0,percent:0},notFinished:{value:0,percent:0}},
                trackingStatus:{}
			},
			loadingPanels:false,
			tabActive:null
        }
    },
    methods: {
        onPageChange(page) {        
            this.offsetTable = (page - 1)  * this.perPage
            this.search();
        },
        search(format = "") {

            this.loading    = true
            this.table.body = []

            api(this)
            .get(`/reports/${this.codeReport}`, {
                params: {
                 filters: {...this.filters, perPage: this.perPage, offset: this.offsetTable},
                    format: format
                }
            })
            .then(res => {
                const data = res.data;
                this.table.body = data.rows
                this.totalRows  = data.totalRows
                this.events     = data
                this.panels     = data.resumeOperation
            })
            .catch(error => {
                this.$root.handleRequestError(error);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        getDriverEventData(events, driver_event_name) {
            
            const event = events.find((ele) => { 
                return ele.transportServiceTrackingStatus === driver_event_name
            })

            if (event) {
                return {
                    date: moment(event.creationDatetime).format("YYYY-MM-DD HH:mm:ss"),
                    dateUtc: moment(event.creationDatetime).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
                    user: `${event.user_driver.firstName} ${event.user_driver.lastName}`,
                };
            }

            return null
        },
        updateTable() {
            this.search()
        },
        excel() {
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters,
						format: "excel"
					},
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "driverEvents");
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {});
		},
        showMap(service) {
            this.serviceSelected = service
            this.$refs['modal-map-events'].show()
        },
        getDataTrackingStatus(trackingStatusCode, field) {
			if (typeof this.panels.trackingStatus[trackingStatusCode] ==='undefined') 
                return 0;
			try {
				return this.panels.trackingStatus[trackingStatusCode][field];
			} catch(err) {
				console.log(err)
			}

			return 0;
		}
    },
    mounted() {
      this.$root.auxVars.loadResourcesOpts({
        vm: this, 
        resourceNames: [
          'salesChannelsOpts',
          'masterZonedAreasOpts',
          'suppliersOpts',
          'transportServiceStatusOpts'
        ]
      })
    },
    computed: {
        filtersClean() {
			return {
				salesChannel: this.filters.salesChannels.map(aux => aux.value),
				supplier: this.filters.suppliers.map(aux => aux.value),
				pickupStartDate: this.filters.startDate,
				pickupEndDate: this.filters.endDate,
				trip: this.filters.trip,
				status: this.filters.status.map(aux => aux.value),
				zones: this.filters.zones,
			};
		},
		trackingStatus(){
			return this.$root.auxVars.transportServiceTrackingStatusOpts
		},
        suppliersOpts() {
            return [
            {
                group: "SELECT ALL",
                options: this.$root.auxVars.suppliersOpts.map((sp) => ({
                value: sp.id,
                text: sp.code
                }))
            }
            ];
        },
        statusOpts() {
            return [
                {
                    group: "SELECT ALL",
                    options: this.$root.auxVars.transportServiceStatusOpts
                }
            ];
        },
        zonesOptions() {
            let aux= [...this.$root.auxVars.masterZonedAreasOpts.map((zam) => ({
                value: zam.id,
                text: zam.name,
                }))];
            return aux;

        },
        channelOpts(){
            let aux= [...this.$root.auxVars.salesChannelsOpts.map((sc) => ({
                value: sc.id,
                text: sc.code,
                }))];
            return aux;
        },
        zonedAreasGroupedOpts(){
            let grouped = [];
            this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
                let item = {
                    zonedArea:ele.name,
                    zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
                };
                grouped.push(item)
            })
            return grouped
		},
        tripOpts() {
            let aux = [...this.$root.auxVars.tripOpts];
            aux.unshift({ value: "all", text: "Todos" });
            return aux;
        },
        statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
        variantStatus() {
            return {
                "pending" : "secondary",
                "active" : "default",
                "noShow" : "info",
                "noProvided": "warning",
                "canceled": "danger",
                "done": "success",
                "partialCancellation": "partialCancellation"
            }
        },
        offset() {
			return (this.currentPage - 1) * this.perPage;
		},
        rowsFrom() {
			return this.offset + 1;
		},
		rowsTo() {
			return Math.min(this.offset + this.perPage, this.totalRows);
		},
        rowsMessage() {
			return (
				"Mostrando " +
				this.rowsFrom +
				" a " +
				this.rowsTo +
				" registros de " +
				this.totalRows
			);
		}
    }
}

</script>


<style scoped>
    .active {
        color: cornflowerblue;
    }
    #perPageSelector {
        width: 80px;
    }
</style>
